module.exports = __webpack_public_path__ + "media/img/chat-dd551e0592ca6927d168b0b824163e43.jpg";